import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
  SlDrawer,
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "sheetjs-style";
import { toLakhs, getBrandOptions } from "../../utils/constants";
import YearCalendar from "../../shared/YearlyCalendar";
import { useSelector } from "react-redux";

function MonthlyVsEenadu() {

  const [data, setData] = useState([{}]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const [showBrands, setShowBrands] = useState(false);
  const [brandsData, setBrandsData] = useState({});
  const [mergeData, setMergeData] = useState({})
  const [totalForEachbrand,setTotalForEachbrand] = useState( {
    PAM: 0,
    PFM: 0,
    WFM: 0,
    UVM: 0,
  })
  function formatSpentValue(value) {
    value = +value
    if (value < 1000) {
      return `${value.toFixed(2)}`;
    } else if (value >= 1000 && value < 100000) {
      const kValue = (value / 1000).toFixed(2);
      return `${kValue}K`;
    } else if (value >= 100000 && value < 10000000) {
      const lValue = (value / 100000).toFixed(2);
      return `${lValue}L`;
    } else if (value >= 10000000) {
      const crValue = (value / 10000000).toFixed(2);
      return `${crValue}Cr`;
    } else {
      return 0;
    }
  }
  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_reports/monthlysofarrevenue",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          type: selectedType,
          year: selectedYear,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if (res.data.userType !== -1) {
          setSelectedType(`${res.data.userType}`);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const tableData = [
        [
          "Month",
          `${selectedNewspaper} all Clients`,
          `${selectedNewspaper} all Insertions`,
          `${selectedNewspaper} all Revenue`,
          `${selectedNewspaper} Mapped Finite Clients`,
          `${selectedNewspaper} Mapped Finite Insertions`,
          `${selectedNewspaper} Mapped Finite Revenue`,
          "Way2news all mapped (finite) Clients",
          "Way2news all mapped (finite) Insertions",
          "Way2news all mapped (finite) Revenue",
          "Eenadu Finite Univ on Way2news Clients",
          "Eenadu Finite Univ on Way2news Insertions",
          "Eenadu Finite Univ on Way2news Revenue",
          `Way2news Vs ${selectedNewspaper} client conv %`,
          `Way2news Vs ${selectedNewspaper} Insertions conv %`,
          `Way2news Vs ${selectedNewspaper} Rev conv %`,
        ],
      ];

      let totalAllClients = 0,
        totalAllInsertions = 0,
        totalAllRevenue = 0,
        totalFiniteClients = 0,
        totalFiniteInsertions = 0,
        totalFiniteRevenue = 0,
        totalWay2newsClients = 0,
        totalWay2newsInsertions = 0,
        totalWay2newsRevenue = 0,
        totalUnivClients = 0,
        totalUnivInsertions = 0,
        totalUnivRevenue = 0;

      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ];

      months.forEach((monthName, index) => {
        const monthKey = (index + 1).toString();
        const newspaperAll =
          data?.data[monthKey]?.[`${selectedNewspaper}`] || {};
        const newspaperFinite =
          data?.data[monthKey]?.[`${selectedNewspaper}_finite`] || {};
        const way2newsFinite = data?.data[monthKey]?.["Way2news_finite"] || {};
        const newspaperUniv =
          data?.data[monthKey]?.[`${selectedNewspaper}_univ`] || {};

        // Conversion calculations
        const clientConv =
          newspaperFinite.clients && newspaperUniv.clients
            ? ((newspaperUniv.clients / newspaperFinite.clients) * 100).toFixed(
                2
              ) + "%"
            : "0%";

        const insertConv =
          newspaperFinite.insertions && newspaperUniv.insertions
            ? (
                (newspaperUniv.insertions / newspaperFinite.insertions) *
                100
              ).toFixed(2) + "%"
            : "0%";

        const revConv =
          newspaperFinite.revenue && newspaperUniv.revenue
            ? ((newspaperUniv.revenue / newspaperFinite.revenue) * 100).toFixed(
                2
              ) + "%"
            : "0%";

        // Summing up totals
        totalAllClients += Number(newspaperAll.clients) || 0;
        totalAllInsertions += Number(newspaperAll.insertions) || 0;
        totalAllRevenue += Number(newspaperAll.revenue) || 0;

        totalFiniteClients += Number(newspaperFinite.clients) || 0;
        totalFiniteInsertions += Number(newspaperFinite.insertions) || 0;
        totalFiniteRevenue += Number(newspaperFinite.revenue) || 0;

        totalWay2newsClients += Number(way2newsFinite.clients) || 0;
        totalWay2newsInsertions += Number(way2newsFinite.insertions) || 0;
        totalWay2newsRevenue += Number(way2newsFinite.revenue) || 0;

        totalUnivClients += Number(newspaperUniv.clients) || 0;
        totalUnivInsertions += Number(newspaperUniv.insertions) || 0;
        totalUnivRevenue += Number(newspaperUniv.revenue) || 0;

        tableData.push([
          monthName,
          newspaperAll.clients || 0,
          newspaperAll.insertions || 0,
          newspaperAll.revenue || 0,
          newspaperFinite.clients || 0,
          newspaperFinite.insertions || 0,
          newspaperFinite.revenue || 0,
          way2newsFinite.clients || 0,
          way2newsFinite.insertions || 0,
          way2newsFinite.revenue || 0,
          newspaperUniv.clients || 0,
          newspaperUniv.insertions || 0,
          newspaperUniv.revenue || 0,
          clientConv,
          insertConv,
          revConv,
        ]);
      });

      // Total conversion calculations
      const totalClientConv = totalFiniteClients
        ? ((totalUnivClients / totalFiniteClients) * 100).toFixed(2) + "%"
        : "0%";

      const totalInsertConv = totalFiniteInsertions
        ? ((totalUnivInsertions / totalFiniteInsertions) * 100).toFixed(2) + "%"
        : "0%";

      const totalRevConv = totalFiniteRevenue
        ? ((totalUnivRevenue / totalFiniteRevenue) * 100).toFixed(2) + "%"
        : "0%";

      // Adding total row
      tableData.push([
        "Total",
        totalAllClients,
        totalAllInsertions,
        totalAllRevenue,
        totalFiniteClients,
        totalFiniteInsertions,
        totalFiniteRevenue,
        totalWay2newsClients,
        totalWay2newsInsertions,
        totalWay2newsRevenue,
        totalUnivClients,
        totalUnivInsertions,
        totalUnivRevenue,
        totalClientConv,
        totalInsertConv,
        totalRevConv,
      ]);
      // const merges = [];
      // merges.push({ s: { r: 0, c: 1 }, e: { r: 0, c: 3 } });
      // merges.push({ s: { r: 0, c: 4 }, e: { r: 0, c: 6 } });
      // merges.push({ s: { r: 0, c: 7 }, e: { r: 0, c: 9 } });
      // merges.push({ s: { r: 0, c: 10 }, e: { r: 0, c: 12 } });
      // merges.push({ s: { r: 0, c: 13 }, e: { r: 0, c: 15 } });
      const worksheet = XLSX.utils.aoa_to_sheet([...tableData]);
      // worksheet["!merges"] = merges;
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        `Monthly vs ${selectedNewspaper}`
      );
      XLSX.writeFile(workbook, `monthlyvsnewspaper.xlsx`);
    } catch (error) {
      console.error(error, "Monthly vs Newspaper");
    } finally {
      setDownloadLoader(false);
    }
  };

  useEffect(() => {
    fetchNewspapers();
  }, []);

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedType, selectedYear]);
  const handleRequestClose = (event) => {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  };

  const buildMapping = () => {
    const indexes = {
      PAM: 0,
      PFM: 1,
      WFM: 2,
      UVM: 3
    }
    let mergedata = {}
    let sumOfBrands = {
      PAM: 0,
      PFM: 0,
      WFM: 0,
      UVM: 0,
    }
    Object.keys(brandsData).map((key, index) => {
      if (index === 0) {
        brandsData[key]?.map((item, _) => {
          if(!mergedata.hasOwnProperty(item.brand_name)) mergedata[item.brand_name] = [0, 0, 0, 0,item.category, item.sales_name,item.brand_location]
          mergedata[item.brand_name][indexes[key]] += item.amount;
          sumOfBrands[key] += item.amount
        })
      }
      else {
        brandsData[key]?.map((item, _) => {
          if (mergedata.hasOwnProperty(item.brand_name)) {
            mergedata[item.brand_name][indexes[key]] += item.amount;
            sumOfBrands[key] += item.amount
          }
        })
      }
    })
    setTotalForEachbrand(sumOfBrands);
    setMergeData(mergedata)
  }
const downloadBrandWiseData = (mergeData, totalForEachbrand, selectedNewspaper) => {
    try {
      const sheetData = [];

      // Define a reusable border style
      const borderStyle = {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      };

      // Header row (bold with border)
      sheetData.push([
        { v: "Brand Name", s: { font: { bold: true }, border: borderStyle } },
        { v: `${selectedNewspaper} All`, s: { font: { bold: true }, border: borderStyle } },
        { v: `${selectedNewspaper} Finite`, s: { font: { bold: true }, border: borderStyle } },
        { v: "W2N Finite", s: { font: { bold: true }, border: borderStyle } },
        { v: "W2N Univ", s: { font: { bold: true }, border: borderStyle } },
        { v: "Category", s: { font: { bold: true }, border: borderStyle } },
        { v: "Sales Person", s: { font: { bold: true }, border: borderStyle } },
        { v: "Brand Location", s: { font: { bold: true }, border: borderStyle } },
      ]);

      // Data rows with background + border
      Object.keys(mergeData).forEach((brand) => {
        const row = [
          { v: brand, s: { border: borderStyle } },
          ...mergeData[brand].map((value) => ({
            v: value || 0,
            s: {
              fill: {
                fgColor: {
                  rgb: value > 0 ? "C6EFCE" : "FFC7CE" // light green or light red
                }
              },
              border: borderStyle
            }
          })),
        ];
        sheetData.push(row);
      });

      // Total row
      const totalRow = [
        { v: "Total", s: { font: { bold: true }, border: borderStyle } },
        ...["PAM", "PFM", "WFM", "UVM"].map((key) => {
          const value = totalForEachbrand[key] || 0;
          return {
            v: value,
            s: {
              font: { bold: true, color: { rgb: "000000" } },
              fill: {
                fgColor: {
                  rgb: value > 0 ? "C6EFCE" : "FFC7CE"
                }
              },
              border: borderStyle
            }
          };
        }),
      ];
      sheetData.push(totalRow);

      // Export
      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Brand Wise Data");

      XLSX.writeFile(workbook, `BrandWiseData_${selectedNewspaper}.xlsx`);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };
  useEffect(() => {
    if (Object.keys(brandsData).length) {
      buildMapping();
    }
  }, [brandsData]);
  
  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Monthly so far VS Eenadu</h5>
        <aside className="flex flex-wrap items-end gap-4 p-4 bg-white rounded-md shadow-sm">
          <div className="flex flex-col min-w-[150px]">
            <label className="text-sm font-medium text-gray-700 mb-1">Team</label>
            <SlSelect
              size="small"
              value={selectedType}
              onSlChange={(e) => setSelectedType(e.target.value)}
            >
              {data?.userType === -1 && <SlOption value="all">All</SlOption>}
              {getBrandOptions(data?.userType, localStorage.getItem("email"))?.map(
                (type) => (
                  <SlOption key={type.value} value={type.value}>
                    {type.label}
                  </SlOption>
                )
              )}
            </SlSelect>
          </div>

          <div className="flex flex-col min-w-[150px]">
            <label className="text-sm font-medium text-gray-700 mb-1">Year</label>
            <YearCalendar startYear={2023} endYear={2100} />
          </div>

          <div className="flex flex-col min-w-[150px]">
            <label className="text-sm font-medium text-gray-700 mb-1">Newspaper</label>
            <SlSelect
              size="small"
              value={selectedNewspaper}
              onSlChange={(e) => setSelectedNewspaper(e.target.value)}
            >
              {newspapers.map((paper) => (
                <SlOption key={paper.name} value={paper.name}>
                  {paper.name}
                </SlOption>
              ))}
            </SlSelect>
          </div>

          <div className="flex items-end h-[38px]">
            {downloadLoader ? (
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <sl-tooltip content="Download" placement="top">
                <div
                  className="w-9 h-9 flex items-center justify-center bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-cyan-600 rounded-md cursor-pointer"
                  onClick={getdownloadData}
                >
                  <SlIcon library="lucide" name="download" />
                </div>
              </sl-tooltip>
            )}
          </div>
        </aside>

      </div>
      <ScrollContainer>
        <table className="table table-bordered tbodyscroll">
          <thead className="bg-yellow-300">
            <tr>
              <th></th>
              <th colSpan={3}>{selectedNewspaper} all</th>
              <th colSpan={3}>{selectedNewspaper} Mapped Finite</th>
              <th colSpan={3}>Way2news all mapped (finite)</th>
              <th colSpan={3}>Eenadu Finite Univ on Way2news</th>
              <th colSpan={3}>Way2news Vs {selectedNewspaper} %</th>
            </tr>
            <tr>
              <th>Date</th>
              <th>Clients</th>
              <th>Insertions</th>
              <th>Revenue</th>
              <th>Clients</th>
              <th>Insertions</th>
              <th>Revenue</th>
              <th>Clients</th>
              <th>Insertions</th>
              <th>Revenue</th>
              <th>Clients</th>
              <th>Insertions</th>
              <th>Revenue</th>
              <th>client conv %</th>
              <th>Insertions conv %</th>
              <th>Rev conv %</th>
            </tr>
          </thead>
          {!loader && Object.keys(data?.data || {})?.length > 0 ? (
            <tbody>
              {(() => {
                let totalAllClients = 0,
                  totalAllInsertions = 0,
                  totalAllRevenue = 0,
                  totalFiniteClients = 0,
                  totalFiniteInsertions = 0,
                  totalFiniteRevenue = 0,
                  totalWay2newsClients = 0,
                  totalWay2newsInsertions = 0,
                  totalWay2newsRevenue = 0,
                  totalUnivClients = 0,
                  totalUnivInsertions = 0,
                  totalUnivRevenue = 0;

                // Sets to track unique brands
                const uniqueNewspaperBrands = new Set();
                const uniqueFiniteBrands = new Set();
                const uniqueW2NBrands = new Set();
                const uniqueUnivBrands = new Set();

                const monthRows = [
                  "Jan",
                  "Feb",
                  "Mar",
                  "Apr",
                  "May",
                  "Jun",
                  "Jul",
                  "Aug",
                  "Sept",
                  "Oct",
                  "Nov",
                  "Dec",
                ].map((monthName, index) => {
                  const monthKey = (index + 1).toString();
                  const newspaperAll =
                    data?.data[monthKey]?.[`${selectedNewspaper}`] || {};
                  const newspaperFinite =
                    data?.data[monthKey]?.[`${selectedNewspaper}_finite`] || {};
                  const way2newsFinite =
                    data?.data[monthKey]?.[`Way2news_finite`] || {};
                  const newspaperUniv =
                    data?.data[monthKey]?.[`Way2news_univ`] || {};

                  // Conversion calculations
                  const clientConv =
                    newspaperFinite.clients && newspaperUniv.clients
                      ? (
                          (newspaperUniv.clients / newspaperFinite.clients) *
                          100
                        ).toFixed(2)
                      : "0";

                  const insertConv =
                    newspaperFinite.insertions && newspaperUniv.insertions
                      ? (
                          (newspaperUniv.insertions /
                            newspaperFinite.insertions) *
                          100
                        ).toFixed(2)
                      : "0";

                  const revConv =
                    newspaperFinite.revenue && newspaperUniv.revenue
                      ? (
                          (newspaperUniv.revenue / newspaperFinite.revenue) *
                          100
                        ).toFixed(2)
                      : "0";

                  // Summing up totals
                  totalAllClients += Number(newspaperAll.clients) || 0;
                  totalAllInsertions += Number(newspaperAll.insertions) || 0;
                  totalAllRevenue += Number(newspaperAll.revenue) || 0;

                  totalFiniteClients += Number(newspaperFinite.clients) || 0;
                  totalFiniteInsertions +=
                    Number(newspaperFinite.insertions) || 0;
                  totalFiniteRevenue += Number(newspaperFinite.revenue) || 0;

                  totalWay2newsClients += Number(way2newsFinite.clients) || 0;
                  totalWay2newsInsertions +=
                    Number(way2newsFinite.insertions) || 0;
                  totalWay2newsRevenue += Number(way2newsFinite.revenue) || 0;

                  totalUnivClients += Number(newspaperUniv.clients) || 0;
                  totalUnivInsertions += Number(newspaperUniv.insertions) || 0;
                  totalUnivRevenue += Number(newspaperUniv.revenue) || 0;

                  // Collect unique brands
                  newspaperAll.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueNewspaperBrands.add(brand.brand_name);
                    }
                  });
                  
                  newspaperFinite.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueFiniteBrands.add(brand.brand_name);
                    }
                  });
                  
                  way2newsFinite.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueW2NBrands.add(brand.brand_name);
                    }
                  });
                  
                  newspaperUniv.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueUnivBrands.add(brand.brand_name);
                    }
                  });

                  return (
                    <tr key={index}>
                      <td className="!bg-orange-100">{monthName}</td>
                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({
                            PAM: newspaperAll.brand_amounts,
                            PFM: newspaperFinite.brand_amounts,
                            WFM: way2newsFinite.brand_amounts,
                            UVM: newspaperUniv.brand_amounts,
                          });
                        }}
                      >
                        {newspaperAll.clients || 0}
                      </td>
                      <td>{newspaperAll.insertions || 0}</td>
                      <td>{toLakhs(newspaperAll.revenue || 0)}</td>

                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({

                            PFM: newspaperFinite.brand_amounts,
                            PAM: newspaperAll.brand_amounts,
                            WFM: way2newsFinite.brand_amounts,
                            UVM: newspaperUniv.brand_amounts,
                          });
                        }}
                      >
                        {newspaperFinite.clients || 0}
                      </td>
                      <td>{newspaperFinite.insertions || 0}</td>
                      <td>{toLakhs(newspaperFinite.revenue || 0)}</td>

                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({

                            WFM: way2newsFinite.brand_amounts,
                            PAM: newspaperAll.brand_amounts,
                            PFM: newspaperFinite.brand_amounts,
                            UVM: newspaperUniv.brand_amounts,
                          });
                        }}
                      >
                        {way2newsFinite.clients || 0}
                      </td>
                      <td>{way2newsFinite.insertions || 0}</td>
                      <td>{toLakhs(way2newsFinite.revenue || 0)}</td>

                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({

                            UVM: newspaperUniv.brand_amounts,
                            PAM: newspaperAll.brand_amounts,
                            PFM: newspaperFinite.brand_amounts,
                            WFM: way2newsFinite.brand_amounts,
                          });
                        }}
                      >
                        {newspaperUniv.clients || 0}
                      </td>
                      <td>{newspaperUniv.insertions || 0}</td>
                      <td>{toLakhs(newspaperUniv.revenue || 0)}</td>

                      <td>{clientConv}%</td>
                      <td>{insertConv}%</td>
                      <td>{revConv}%</td>
                    </tr>
                  );
                });

                // Total conversion calculations
                const totalClientConv =
                  totalFiniteClients && totalUnivClients
                    ? ((totalUnivClients / totalFiniteClients) * 100).toFixed(2)
                    : "0";

                const totalInsertConv =
                  totalFiniteInsertions && totalUnivInsertions
                    ? (
                        (totalUnivInsertions / totalFiniteInsertions) *
                        100
                      ).toFixed(2)
                    : "0";

                const totalRevConv =
                  totalFiniteRevenue && totalUnivRevenue
                    ? ((totalUnivRevenue / totalFiniteRevenue) * 100).toFixed(2)
                    : "0";

                return (
                  <>
                    {monthRows}
                    {/* Total Row */}
                    <tr className="bg-gray-300 font-bold">
                      <td>Total</td>
                      <td title={`Clients total: ${totalAllClients}, unique: ${uniqueNewspaperBrands.size}`}>{uniqueNewspaperBrands.size}</td>
                      <td>{totalAllInsertions}</td>
                      <td title={`Revenue: ${toLakhs(totalAllRevenue)}`}>{toLakhs(totalAllRevenue)}</td>

                      <td title={`Clients total: ${totalFiniteClients}, unique: ${uniqueFiniteBrands.size}`}>{uniqueFiniteBrands.size}</td>
                      <td>{totalFiniteInsertions}</td>
                      <td title={`Revenue: ${toLakhs(totalFiniteRevenue)}`}>{toLakhs(totalFiniteRevenue)}</td>

                      <td title={`Clients total: ${totalWay2newsClients}, unique: ${uniqueW2NBrands.size}`}>{uniqueW2NBrands.size}</td>
                      <td>{totalWay2newsInsertions}</td>
                      <td title={`Revenue: ${toLakhs(totalWay2newsRevenue)}`}>{toLakhs(totalWay2newsRevenue)}</td>

                      <td title={`Clients total: ${totalUnivClients}, unique: ${uniqueUnivBrands.size}`}>{uniqueUnivBrands.size}</td>
                      <td>{totalUnivInsertions}</td>
                      <td title={`Revenue: ${toLakhs(totalUnivRevenue)}`}>{toLakhs(totalUnivRevenue)}</td>

                      <td>{totalClientConv}%</td>
                      <td>{totalInsertConv}%</td>
                      <td>{totalRevConv}%</td>
                    </tr>
                  </>
                );
              })()}
            </tbody>
          ) : loader ? (
            <TableSkelton rowSpan={15} colspan={16} />
          ) : (
            <NoDataFound colspan={16} />
          )}
        </table>
      </ScrollContainer>
      <SlDrawer
        open={showBrands}
        onSlAfterHide={() => {
          setShowBrands(false);
        }}
        onSlRequestClose={handleRequestClose}
        style={{ "--size": `${window.innerWidth <= 767 ? "100%" : '40%'}` }}
      >
        <div className="flex justify-end mb-4">
          <i className="bi bi-download px-2 py-1 rounded-lg bg-slate-100 hover:bg-yellow-300 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download"
            onClick={() => downloadBrandWiseData(mergeData, totalForEachbrand, selectedNewspaper)}></i>
        </div>

        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Brand Name</th>
              <th>Sales Person</th>
              <th>Brand Location</th>
              <th>Category</th>
              <th>{selectedNewspaper} All</th>
              <th>{selectedNewspaper} Finite</th>
              <th>W2N Finite</th>
              <th>W2N Univ</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(mergeData)?.map((brand) => (
              <tr key={brand}>
                <td title={brand} className="truncate">{brand}</td>
                <td>{mergeData[brand][5]}</td>
                <td>{mergeData[brand][6]}</td>
                <td>{mergeData[brand][4]}</td>
                <td>{formatSpentValue(mergeData[brand][0])}</td>
                <td>{formatSpentValue(mergeData[brand][1])}</td>
                <td>{formatSpentValue(mergeData[brand][2])}</td>
                <td>{formatSpentValue(mergeData[brand][3])}</td>
              </tr>
            ))}
            <tr className="font-bold">
              <td>Total</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{formatSpentValue(totalForEachbrand['PAM'])}</td>
              <td>{formatSpentValue(totalForEachbrand['PFM'])}</td>
              <td>{formatSpentValue(totalForEachbrand['WFM'])}</td>
              <td>{formatSpentValue(totalForEachbrand['UVM'])}</td>
            </tr>
          </tbody>
        </table>
      </SlDrawer>

    </>
  );
}

export default MonthlyVsEenadu;
